const DEFAULT_IDM_BASE = "https://idm.werbeauto.ch" as const;
const KNOWN_APP_SUBDOMAINS = ["admin", "advertiser", "demo", "idm"] as const;
const KNOWN_APP_PREFIXES = [
  "admin",
  "admin-portal",
  "adminportal",
  "advertiser",
  "advertiser-portal",
  "advertiserportal",
  "demo",
  "demo-portal",
  "demoportal",
  "idm",
] as const;

const normalizeBaseUrl = (value?: string) => {
  const normalized = typeof value === "string" ? value.trim() : "";
  return normalized ? normalized.replace(/\/$/, "") : "";
};

const deriveIdmBaseFromHostname = (hostname: string, protocol: string) => {
  if (!hostname) {
    return "";
  }

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "";
  }

  const segments = hostname.split(".").filter(Boolean);
  if (!segments.length) {
    return "";
  }

  const firstSegment = segments[0].toLowerCase();
  const baseSegments =
    (KNOWN_APP_SUBDOMAINS.includes(firstSegment as (typeof KNOWN_APP_SUBDOMAINS)[number]) ||
      KNOWN_APP_PREFIXES.includes(firstSegment as (typeof KNOWN_APP_PREFIXES)[number])) &&
    segments.length > 1
      ? segments.slice(1)
      : segments;

  if (!baseSegments.length) {
    return "";
  }

  return `${protocol}//idm.${baseSegments.join(".")}`;
};

const envBase = normalizeBaseUrl(process.env.REACT_APP_IDM_BASE_URL);
const runtimeBase =
  typeof window !== "undefined"
    ? deriveIdmBaseFromHostname(window.location.hostname, window.location.protocol)
    : "";

export const IDM_BASE_URL = envBase || runtimeBase || DEFAULT_IDM_BASE;
export const buildIdmUrl = (path = "") =>
  path ? `${IDM_BASE_URL}${path.startsWith("/") ? path : `/${path}`}` : IDM_BASE_URL;
